import routeHomePages from './HomePage';
import routeHomePageAdmins from './Admin';

export default {
    routeHomePages,
    routeHomePageAdmins
};
